var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-row flex-wrap"},[_c('div',{staticClass:"cardDtl"},[_c('div',{staticClass:"thumbnail"}),_c('h1'),_c('p')])])}]

export { render, staticRenderFns }